import { render, staticRenderFns } from "./UpdateNotes.vue?vue&type=template&id=4410f1ad&scoped=true&"
import script from "./UpdateNotes.vue?vue&type=script&lang=js&"
export * from "./UpdateNotes.vue?vue&type=script&lang=js&"
import style0 from "./UpdateNotes.vue?vue&type=style&index=0&id=4410f1ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4410f1ad",
  null
  
)

export default component.exports